export enum TaxCodes {
  ACCOUNT_DEFAULT = "default",
  GENERAL_TANGIBLE_GOODS = "txcd_99999999",
  GENERAL_SERVICES = "txcd_20030000",
  GENERAL_ELECTRONIC_SERVICES = "txcd_10000000",
  NONTAXABLE = "txcd_00000000",
  IAAS_PERSONAL = "txcd_10010001",
  IAAS_BUSINESS = "txcd_10101000",
  PAAS_BUSINESS = "txcd_10102000",
  PAAS_PERSONAL = "txcd_10102001",
  SAAS_PERSONAL = "txcd_10103000",
  SAAS_BUSINESS = "txcd_10103001",
  SAAS_DOWNLOAD_PERSONAL = "txcd_10103100",
  SAAS_DOWNLOAD_BUSINESS = "txcd_10103101",
  CLOUD_BUSINESS = "txcd_10104001",
  GAMES_DOWNLOAD_PERMANENT = "txcd_10201000",
  GAMES_DOWNLOAD_LIMITED = "txcd_10201001",
  GAMES_DOWNLOAD_SUBSCRIPTION = "txcd_10201002",
  GAMES_STREAM_LIMITED = "txcd_10201003",
  GAMES_STREAM_SUBSCRIPTION = "txcd_10201004",
  SOFTWARE_DOWNLOAD_PERSONAL = "txcd_10202000",
  SOFTWARE_DOWNLOAD_NONREC = "txcd_10202001",
  SOFTWARE_DOWNLOAD_BUSINESS = "txcd_10202003",
  SOFTWARE_CUSTOM_PERSONAL = "txcd_10203000",
  SOFTWARE_CUSTOM_BUSINESS = "txcd_10203001",
  AUDIOBOOK = "txcd_10301000",
  BOOKS_DOWNLOAD_PERMANENT = "txcd_10302000",
  BOOKS_DOWNLOAD_LIMITED = "txcd_10302001",
  BOOKS_DOWNLOAD_SUBSCRIPTION = "txcd_10302002",
  BOOKS_VIEW_SUBSCRIPTION = "txcd_10302003",
  MAGAZINES_DOWNLOAD_SUBSCRIPTION = "txcd_10303000",
  MAGAZINES_TANGIBLE_DIGITAL = "txcd_10303001",
  MAGAZINES_VIEW_SUBSCRIPTION = "txcd_10303002",
  MAGAZINES_DOWNLOAD_PERMANENT = "txcd_10303100",
  MAGAZINES_VIEW_LIMITED = "txcd_10303101",
  MAGAZINES_VIEW_PERMANENT = "txcd_10303102",
  MAGAZINES_DOWNLOAD_LIMITED = "txcd_10303104",
  NEWSPAPERS_DOWNLOAD_PERMANENT = "txcd_10304000",
  NEWSPAPERS_VIEW_LIMITED = "txcd_10304001",
  NEWSPAPERS_VIEW_PERMANENT = "txcd_10304002",
  NEWSPAPERS_DOWNLOAD_LIMITED = "txcd_10304003",
  NEWSPAPERS_DOWNLOAD_SUBSCRIPTION = "txcd_10304100",
  NEWSPAPERS_TANGIBLE_DIGITAL = "txcd_10304101",
  NEWSPAPERS_VIEW_SUBSCRIPTION = "txcd_10304102",
  TEXTBOOKS_DOWNLOAD_LIMITED = "txcd_10305000",
  TEXTBOOKS_DOWNLOAD_PERMANENT = "txcd_10305001",
  AUDIO_STREAM_LIMITED = "txcd_10401000",
  AUDIO_DOWNLOAD_LIMITED = "txcd_10401001",
  AUDIO_DOWNLOAD_PERMANENT = "txcd_10401100",
  AUDIO_STREAM_SUBSCRIPTION = "txcd_10401200",
  AUDIOVISUAL_STREAM_LIMITED = "txcd_10402000",
  AUDIOVISUAL_DOWNLOAD_PERMANENT = "txcd_10402100",
  AUDIOVISUAL_DOWNLOAD_LIMITED = "txcd_10402110",
  AUDIOVISUAL_STREAM_SUBSCRIPTION = "txcd_10402200",
  VIDEO_STREAM_LIVE = "txcd_10402300",
  PHOTOS_DOWNLOAD_PERMANENT = "txcd_10501000",
  GIFT_CARD = "txcd_10502000",
  NEWS_DOWNLOAD_PERMANENT = "txcd_10503000",
  NEWS_DOWNLOAD_LIMITED = "txcd_10503001",
  NEWS_DOWNLOAD_SUBSCRIPTION = "txcd_10503002",
  NEWS_VIEW_LIMITED = "txcd_10503003",
  NEWS_VIEW_PERMANENT = "txcd_10503004",
  NEWS_VIEW_SUBSCRIPTION = "txcd_10503005",
  SOFTWARE_DOCS_CUSTOM = "txcd_10504000",
  SOFTWARE_DOCS_PREWRITTEN = "txcd_10504003",
  ARTWORK_DOWNLOAD_LIMITED = "txcd_10505000",
  ARTWORK_DOWNLOAD_PERMANENT = "txcd_10505001",
  ARTWORK_DOWNLOAD_SUBSCRIPTION = "txcd_10505002",
  GREETING_CARDS_AUDIO = "txcd_10506000",
  GREETING_CARDS_AUDIOVISUAL = "txcd_10506001",
  GREETING_CARDS_STATIC = "txcd_10506002",
  WEBSITE_ADVERTISING = "txcd_10701000",
  WEBSITE_HOSTING = "txcd_10701100",
  WEBSITE_DESIGN = "txcd_10701200",
  WEBSITE_DATA_PROCESSING = "txcd_10701300",
  WEBSITE_INFO_BUSINESS = "txcd_10701400",
  WEBSITE_INFO_PERSONAL = "txcd_10701401",
  ELECTRONIC_INFO_BUSINESS = "txcd_10701410",
  ELECTRONIC_INFO_PERSONAL = "txcd_10701411",
  ONLINE_DATING = "txcd_10702000",
  AUDIOVISUAL_BUNDLE_DOWNLOAD_STREAM = "txcd_10804001",
  AUDIOVISUAL_BUNDLE_DOWNLOAD_LIMITED = "txcd_10804002",
  AUDIOVISUAL_BUNDLE_DOWNLOAD_PERMANENT = "txcd_10804003",
  AUDIO_BUNDLE_DOWNLOAD_STREAM = "txcd_10804010",
  CAR_WASH = "txcd_20010001",
  CLEANING_PROPERTY = "txcd_20010003",
  CLEANING_COMMERCIAL = "txcd_20010004",
  CLEANING_RESIDENTIAL = "txcd_20010006",
  GUTTER_CLEANING = "txcd_20010007",
  HARDWARE_INSTALL_NONPERMANENT = "txcd_20020009",
  HARDWARE_INSTALL_PERMANENT = "txcd_20020010",
  PROPERTY_INSTALL = "txcd_20020018",
  PET_BOARDING = "txcd_20030002",
  PET_GROOMING = "txcd_20030003",
  PARKING = "txcd_20030004",
  PET_TRAINING = "txcd_20030005",
  HAIRDRESSING = "txcd_20040001",
  PERSONAL_CARE = "txcd_20040002",
  BODY_PIERCING = "txcd_20040003",
  CHILDCARE = "txcd_20040004",
  DATING = "txcd_20040005",
  EMPLOYMENT = "txcd_20040006",
  MANICURE = "txcd_20040007",
  MASSAGE = "txcd_20040008",
  SPA = "txcd_20040009",
  TANNING = "txcd_20040010",
  TATTOOING = "txcd_20040011",
  PROFESSIONAL = "txcd_20060000",
  ACCOUNTING = "txcd_20060001",
  ADVERTISING = "txcd_20060002",
  CREDIT_REPORTING = "txcd_20060008",
  DATA_PROCESSING = "txcd_20060009",
  DEBT_COLLECTION = "txcd_20060010",
  ENGINEERING = "txcd_20060013",
  TECH_SUPPORT = "txcd_20060017",
  INSURANCE = "txcd_20060021",
  INTERIOR_DECORATING = "txcd_20060022",
  LOBBYING = "txcd_20060026",
  MEDICAL_PROFESSIONAL = "txcd_20060027",
  PAYROLL = "txcd_20060029",
  PRIVATE_INVESTIGATOR = "txcd_20060030",
  SECRETARIAL = "txcd_20060035",
  ELECTRONIC_FILING = "txcd_20060040",
  TEMP_HELP = "txcd_20060042",
  TRAINING = "txcd_20060044",
  TRAINING_LIVE = "txcd_20060045",
  ARCHITECTURAL = "txcd_20060047",
  CONSULTING = "txcd_20060048",
  COSMETIC_MEDICAL = "txcd_20060049",
  CREDIT_MONITORING = "txcd_20060050",
  CREDIT_CARD_PROCESSING = "txcd_20060051",
  EDUCATIONAL = "txcd_20060052",
  HOME_INSPECTION = "txcd_20060053",
  LEGAL = "txcd_20060054",
  MARKETING = "txcd_20060055",
  PUBLIC_RELATIONS = "txcd_20060056",
  STENOGRAPHIC = "txcd_20060057",
  TRAINING_SELF_STUDY = "txcd_20060058",
  TUTORING = "txcd_20060059",
  SECURITY_ALARM = "txcd_20070001",
  EXTERMINATION = "txcd_20070006",
  LANDSCAPING = "txcd_20070007",
  LAWN_MAINTENANCE = "txcd_20070008",
  PAINTING_WALLPAPERING = "txcd_20070010",
  SECURITY_GUARD = "txcd_20070013",
  PROPERTY_SURVEYING = "txcd_20070016",
  VEHICLE_REPAIR = "txcd_20080003",
  SHOE_REPAIR = "txcd_20080004",
  PROPERTY_REPAIR = "txcd_20080005",
  REAL_PROPERTY_REPAIR = "txcd_20080007",
  AIRCRAFT_REPAIR = "txcd_20080008",
  APPLIANCE_REPAIR = "txcd_20080009",
  COMPUTER_REPAIR = "txcd_20080010",
  FURNITURE_REUPHOLSTERING = "txcd_20080011",
  JEWELRY_REPAIR = "txcd_20080012",
  MACHINE_REPAIR = "txcd_20080013",
  GARMENT_ALTER_CONJUNCTION = "txcd_20090001",
  GARMENT_ALTER_SEPARATE = "txcd_20090002",
  SHREDDING = "txcd_20090003",
  DRY_CLEANING = "txcd_20090004",
  FABRICATION = "txcd_20090006",
  GIFT_WRAP_CONJUNCTION = "txcd_20090010",
  LINEN_LAUNDRY_ONLY = "txcd_20090012",
  WARRANTY_MANDATORY = "txcd_20090015",
  WARRANTY_OPTIONAL = "txcd_20090018",
  ASSEMBLY_CONJUNCTION = "txcd_20090022",
  ASSEMBLY_PRIOR = "txcd_20090023",
  DRY_CLEANING_OTHER = "txcd_20090024",
  GIFT_WRAP_SEPARATE = "txcd_20090025",
  LINEN_LAUNDRY_ONLY_OTHER = "txcd_20090026",
  MEAT_PROCESSING = "txcd_20090027",
  PRINTING = "txcd_20090028",
  PRINTING_CUSTOMER_SUPPLIED = "txcd_20090029",
  TAXIDERMY = "txcd_20090030",
  ENGRAVING_SEPARATE = "txcd_20090031",
  ENGRAVING_CONJUNCTION = "txcd_20090032",
  WARRANTY_EXTENDED_VEHICLE = "txcd_20091000",
  MAINTENANCE_VEHICLE = "txcd_20091001",
  WARRANTY_EXTENDED_LEASED_VEHICLE = "txcd_20091002",
  MAINTENANCE_LEASED_VEHICLE = "txcd_20091003",
  WARRANTY_EXTENDED_AFTERMARKET = "txcd_20091004",
  MAINTENANCE_AFTERMARKET = "txcd_20091005",
  ARMORED_CAR = "txcd_20100001",
  CLOTHING_FOOTWEAR = "txcd_30011000",
  BELT_BUCKLE = "txcd_30011002",
  BELTS_SUSPENDERS = "txcd_30011003",
  NECK_GAITER = "txcd_30011015",
  SCHOOL_UNIFORMS = "txcd_30011020",
  FUR_CLOTHING_SYNTHETIC = "txcd_30011028",
  SCARVES = "txcd_30011034",
  NECKTIES = "txcd_30011045",
  FORMAL_WEAR = "txcd_30011100",
  CHILDRENS_CLOTHING = "txcd_30011200",
  FUR_CLOTHING = "txcd_30011201",
  ATHLETIC_CLOTHING = "txcd_30021000",
  SWEAT_BANDS = "txcd_30021001",
  SWIMSUITS = "txcd_30021200",
  OCCUPATIONAL_UNIFORMS = "txcd_30030001",
  CLEANROOM_APPAREL = "txcd_30031004",
  REFLECTIVE_APPAREL = "txcd_30031041",
  PROTECTIVE_SAFETY_CLOTHING = "txcd_30031404",
  PROTECTIVE_SAFETY_CLOTHING_OCCUPATIONAL_USE = "txcd_30031405",
  PROTECTIVE_SAFETY_FOOTWEAR = "txcd_30031406",
  PROTECTIVE_SAFETY_FOOTWEAR_OCCUPATIONAL_USE = "txcd_30031407",
  PROTECTIVE_SAFETY_EQUIPMENT = "txcd_30031408",
  PROTECTIVE_SAFETY_EQUIPMENT_OCCUPATIONAL_USE = "txcd_30031409",
  CLOTH_FACE_MASKS = "txcd_30040003",
  COSTUME_MASKS_AND_ACCESSORIES = "txcd_30040005",
  COSTUMES = "txcd_30040006",
  GLOVES_GENERAL_USE = "txcd_30051302",
  PURSES_AND_HANDBAGS = "txcd_30060001",
  HANDKERCHIEFS = "txcd_30060004",
  HAIR_ACCESSORIES = "txcd_30060005",
  HATS = "txcd_30060006",
  JEWELRY = "txcd_30060007",
  NON_CLOTHING_ACCESSORIES = "txcd_30060010",
  SHOWER_CAPS = "txcd_30060011",
  UMBRELLAS = "txcd_30060013",
  WIGS_HAIRPIECES_HAIR_EXTENSIONS = "txcd_30060014",
  LUGGAGE = "txcd_30060015",
  WATCHES = "txcd_30060016",
  SUNGLASSES_NON_PRESCRIPTION = "txcd_30060017",
  WATCHES_SMART = "txcd_30060018",
  BRIEFCASES = "txcd_30060019",
  APRONS = "txcd_30060020",
  BANDANNAS = "txcd_30060021",
  WALLETS = "txcd_30060101",
  BICYCLE_HELMETS_ADULT = "txcd_30070001",
  BICYCLE_HELMETS_YOUTH = "txcd_30070002",
  BALLET_TAP_SHOES = "txcd_30070003",
  BASEBALL_BATTING_GLOVES = "txcd_30070004",
  BOWLING_GLOVES = "txcd_30070005",
  BOWLING_SHOES = "txcd_30070006",
  BOXING_GLOVES = "txcd_30070007",
  CLEATED_SPIKED_SHOES = "txcd_30070008",
  FOOTBALL_RECEIVER_GLOVES = "txcd_30070009",
  GOLF_GLOVES = "txcd_30070010",
  GOLF_SHOES = "txcd_30070011",
  ICE_SKATES = "txcd_30070012",
  LIFE_VESTS = "txcd_30070013",
  MARTIAL_ARTS_ATTIRE = "txcd_30070014",
  MOTORCYCLE_HELMETS = "txcd_30070015",
  MOUTH_GUARDS = "txcd_30070017",
  ROLLER_SKATES_BLADES = "txcd_30070018",
  SHIN_GUARDS = "txcd_30070019",
  SHOULDER_PADS_SPORTS = "txcd_30070020",
  SKI_BOOTS = "txcd_30070021",
  SPORT_UNIFORMS = "txcd_30070022",
  SWIM_FINS = "txcd_30070023",
  SWIM_GOGGLES = "txcd_30070024",
  WETSUIT = "txcd_30070025",
  ATHLETIC_SUPPORTER = "txcd_30070026",
  HUNTING_VESTS = "txcd_30070028",
  HUNTING_CLOTHING = "txcd_30070029",
  SPORTS_EQUIPMENT = "txcd_30071000",
  BUTTON_COVERS = "txcd_30080001",
  COMPONENT_CLOTHING_ITEMS = "txcd_30080002",
  OVERSHOES = "txcd_30090005",
  SHOE_INSERTS = "txcd_30090009",
  SHOELACES = "txcd_30090010",
  BIBS = "txcd_31020001",
  INFANT_SWADDLES = "txcd_31020002",
  INFANT_RECEIVING_BLANKETS = "txcd_31020003",
  DIAPER_CREAM = "txcd_31030001",
  BABY_WIPES = "txcd_31030003",
  INFANT_DIAPERS = "txcd_31031202",
  TODDLER_TRAINING_PANTS = "txcd_31031203",
  DIAPER_LINERS_SINGLE_USE = "txcd_31031204",
  CLOTH_DIAPERS = "txcd_31031205",
  BABY_BOTTLES_NIPPLES = "txcd_31040001",
  BREAST_PUMPS = "txcd_31040002",
  INFANT_CAR_SEAT = "txcd_31070001",
  BLOOD_GLUCOSE_MONITOR = "txcd_32010001",
  DIABETIC_TEST_SUPPLIES = "txcd_32010002",
  BLOOD_GLUCOSE_MONITOR_PRESCRIPTION = "txcd_32010003",
  DIABETIC_TEST_SUPPLIES_PRESCRIPTION = "txcd_32010004",
  PRESCRIPTION_DRUGS = "txcd_32020001",
  OTC_DRUGS = "txcd_32020002",
  OTC_DRUGS_PRESCRIPTION = "txcd_32020003",
  INSULIN_PRESCRIPTION = "txcd_32020004",
  INSULIN = "txcd_32020005",
  MEDICAL_OXYGEN_PRESCRIPTION = "txcd_32020006",
  MEDICAL_OXYGEN = "txcd_32020011",
  CONDOMS = "txcd_32030001",
  CONDOMS_PRESCRIPTION = "txcd_32030002",
  CONDOMS_SPERMICIDE = "txcd_32030003",
  CONDOMS_SPERMICIDE_PRESCRIPTION = "txcd_32030004",
  CONTRACEPTIVE_OINTMENTS = "txcd_32030005",
  BIRTH_CONTROL_OTC_ORAL = "txcd_32030006",
  BIRTH_CONTROL_OTC_ORAL_PRESCRIPTION = "txcd_32030007",
  BIRTH_CONTROL_PRESCRIPTION_BARRIERS = "txcd_32030008",
  BIRTH_CONTROL_PRESCRIPTION_HORMONAL = "txcd_32030009",
  BIRTH_CONTROL_PRESCRIPTION_ORAL = "txcd_32030010",
  FEMININE_CLEANSING = "txcd_32040002",
  FEMININE_CLEANSING_MEDICATED = "txcd_32040003",
  FEMININE_YEAST_TREATMENTS = "txcd_32040004",
  TAMPONS_PADS_LINERS = "txcd_32040005",
  ADULT_DIAPERS = "txcd_32050001",
  DISPOSABLE_FACE_MASKS = "txcd_32050005",
  GROOMING_HYGIENE = "txcd_32050006",
  GROOMING_HYGIENE_MEDICATED = "txcd_32050007",
  HAND_SANITIZERS = "txcd_32050009",
  MEDICATED_ACNE_TREATMENTS = "txcd_32050012",
  SKIN_CARE = "txcd_32050013",
  SKIN_CARE_MEDICATED = "txcd_32050014",
  SMOKING_CESSATION = "txcd_32050015",
  TOILET_TISSUE = "txcd_32050017",
  TOOTHBRUSH = "txcd_32050018",
  TOOTHPASTE = "txcd_32050019",
  BABY_OIL = "txcd_32050020",
  BABY_POWDER = "txcd_32050021",
  BREATH_SPRAY_STRIPS = "txcd_32050022",
  BUBBLE_BATH_SALTS_OILS = "txcd_32050023",
  CONDITIONER_HAIR = "txcd_32050024",
  COSMETICS_BEAUTIFYING = "txcd_32050025",
  DENTAL_FLOSS_PICKS = "txcd_32050026",
  DENTURE_CREAMS_ADHESIVES = "txcd_32050027",
  DEODORANT_NATURAL = "txcd_32050028",
  DEODORANT_ANTIPERSPIRANT = "txcd_32050029",
  HAIR_LOSS_PRODUCTS = "txcd_32050030",
  HAIR_REMOVAL_PRODUCTS = "txcd_32050031",
  LIP_BALM = "txcd_32050032",
  LIP_BALM_MEDICATED = "txcd_32050033",
  MOUTHWASH_COSMETIC = "txcd_32050034",
  MOUTHWASH_THERAPEUTIC = "txcd_32050035",
  SHAMPOO = "txcd_32050036",
  SHAMPOO_MEDICATED = "txcd_32050037",
  SHAVING_CREAMS = "txcd_32050038",
  SOAPS_ANTIBACTERIAL = "txcd_32050039",
  SUNSCREEN = "txcd_32050040",
  TEETH_WHITENING_KITS = "txcd_32050041",
  DURABLE_MEDICAL_EQUIPMENT_HOME = "txcd_32060001",
  MEDICAL_EQUIPMENT_HOME_RX = "txcd_32060002",
  FEEDING_EQUIPMENT_HOME_RX = "txcd_32060007",
  DIALYSIS_EQUIPMENT_HOME_RX = "txcd_32060012",
  DIALYSIS_EQUIPMENT_HOME = "txcd_32060017",
  OXYGEN_EQUIPMENT_HOME_RX = "txcd_32060018",
  OXYGEN_EQUIPMENT_HOME = "txcd_32060023",
  HEATING_PADS = "txcd_32060024",
  THERAPY_PACKS_REUSABLE = "txcd_32060025",
  FEEDING_EQUIPMENT_HOME = "txcd_32060026",
  WOUND_CARE_BANDAGES = "txcd_32070003",
  WOUND_CARE_MEDICATED = "txcd_32070004",
  FIRST_AID_KITS = "txcd_32070018",
  GLOVES_DISPOSABLE_NON_MEDICAL = "txcd_32070019",
  GLOVES_DISPOSABLE_MEDICAL = "txcd_32070020",
  MEDICAL_SUPPLIES_CONSUMABLE = "txcd_32070028",
  FIRST_AID_KITS_50_OR_LESS = "txcd_32070029",
  CONTACT_LENS_CLEANER = "txcd_32070030",
  CONTACT_LENS_LUBRICANT = "txcd_32070031",
  COTTON_SWABS_STERILE = "txcd_32070032",
  COTTON_SWABS_UNSTERILE = "txcd_32070033",
  THERAPY_PACKS = "txcd_32070034",
  THERAPY_PACKS_MEDICATED = "txcd_32070035",
  NASAL_BREATHING_STRIPS = "txcd_32070036",
  INSULIN_NEEDLES_RX = "txcd_32070037",
  INSULIN_NEEDLES = "txcd_32070038",
  HYDROGEN_PEROXIDE = "txcd_32070039",
  PETROLEUM_JELLY = "txcd_32070040",
  EAR_DROPS_MEDICATED = "txcd_32070041",
  ISOPROPYL_RUBBING_ALCOHOL = "txcd_32070042",
  BATH_AIDS = "txcd_32080001",
  MOBILITY_EQUIPMENT = "txcd_32080003",
  MOBILITY_EQUIPMENT_PARTS = "txcd_32080004",
  MOBILITY_EQUIPMENT_RX = "txcd_32080005",
  CORRECTIVE_LENSES = "txcd_32090003",
  HEARING_AID_BATTERIES = "txcd_32090005",
  HEARING_AIDS = "txcd_32090006",
  PROSTHETIC_DEVICE = "txcd_32090007",
  PROSTHETIC_DEVICES_RX = "txcd_32090008",
  CORRECTIVE_LENSES_RX = "txcd_32090013",
  CONTACT_LENSES_RX = "txcd_32090014",
  DENTAL_PROSTHETICS_RX = "txcd_32090015",
  DENTAL_PROSTHETICS = "txcd_32090016",
  HEARING_AIDS_RX = "txcd_32090017",
  HEARING_AID_BATTERIES_RX = "txcd_32090018",
  PREGNANCY_TESTING_KITS = "txcd_32100001",
  OVULATION_TESTING_KITS = "txcd_32100002",
  INFECTIOUS_DISEASE_TEST = "txcd_32100003",
  INFECTIOUS_DISEASE_TEST_RX = "txcd_32100004",
  DNA_TESTING_KITS = "txcd_32100005",
  THERMOMETERS_DISPOSABLE = "txcd_32100006",
  THERMOMETERS_REUSABLE = "txcd_32100007",
  ENERGY_STAR_PRODUCTS = "txcd_32100008",
  BLOOD_PRESSURE_DEVICES = "txcd_32100010",
  PULSE_OXIMETER = "txcd_32100011",
  DRUG_TESTING_KITS = "txcd_32100012",
  CHOLESTEROL_TESTING_KITS = "txcd_32100013",
  CEILING_FANS_ENERGY_STAR = "txcd_33020001",
  AIR_CONDITIONERS_ENERGY_STAR = "txcd_33020002",
  FURNACES_ENERGY_STAR = "txcd_33020003",
  HEAT_PUMPS_ENERGY_STAR = "txcd_33020004",
  WATER_HEATER_ENERGY_STAR = "txcd_33020005",
  DEHUMIDIFIER_ENERGY_STAR = "txcd_33020006",
  BOILERS_ENERGY_STAR = "txcd_33020007",
  THERMOSTAT_ENERGY_STAR = "txcd_33020008",
  REFRIGERATORS_ENERGY_STAR = "txcd_33020009",
  DISHWASHERS_ENERGY_STAR = "txcd_33020010",
  FREEZERS_ENERGY_STAR = "txcd_33020011",
  WASHING_MACHINE_ENERGY_STAR = "txcd_33020012",
  DRYING_MACHINE_ENERGY_STAR = "txcd_33020013",
  CAN_OPENER_MANUAL = "txcd_33020014",
  WATER_EFFICIENT_PRODUCTS_RESIDENTIAL = "txcd_33020200",
  ALKALINE_BATTERIES = "txcd_33030001",
  MOBILE_PHONE_BATTERIES = "txcd_33031001",
  DISINFECTANT_WIPES = "txcd_33080201",
  DISPOSABLE_PAPER_PRODUCTS = "txcd_33080202",
  HOUSEHOLD_LINENS_BEDDING = "txcd_33080300",
  BEDDING = "txcd_33080301",
  BATH_MATS_RUGS = "txcd_33080302",
  BATH_TOWELS = "txcd_33080303",
  SHOWER_CURTAIN_LINER = "txcd_33080304",
  CRIB_BUMPERS_LINERS = "txcd_33080305",
  DISH_TOWELS = "txcd_33080306",
  YARN_NON_CLOTHING = "txcd_33080400",
  LANDSCAPE_SOIL_MULCH_RESIDENTIAL = "txcd_33100001",
  GARDEN_CHEMICALS_NONCOMMERCIAL = "txcd_33100101",
  GARDEN_FERTILIZER_NONCOMMERCIAL = "txcd_33100200",
  INCANDESCENT_BULBS_ENERGY_STAR = "txcd_33110001",
  FLUORESCENT_BULBS_ENERGY_STAR = "txcd_33110002",
  LED_BULBS_ENERGY_STAR = "txcd_33110003",
  PORTABLE_LIGHT_SOURCES = "txcd_33110004",
  CANDLES = "txcd_33110005",
  STORM_PREPAREDNESS_ITEMS = "txcd_33120000",
  PORTABLE_RADIOS = "txcd_33120001",
  FOOD_STORAGE_COOLER = "txcd_33120002",
  SMOKE_DETECTORS = "txcd_33120003",
  CARBON_MONOXIDE_DETECTORS = "txcd_33120004",
  FIRE_EXTINGUISHERS = "txcd_33120005",
  PORTABLE_FUEL_CONTAINER = "txcd_33120006",
  WATER_STORAGE_CONTAINER = "txcd_33120007",
  ARTIFICIAL_ICE = "txcd_33120008",
  TARPAULINS_WEATHERPROOF_SHEETING = "txcd_33120009",
  PORTABLE_GENERATOR = "txcd_33120010",
  POWER_CORDS = "txcd_33120011",
  AXES_HATCHETS = "txcd_33120012",
  GARDEN_CHAINSAW = "txcd_33120013",
  CHAINSAW_ACCESSORIES = "txcd_33120014",
  STORM_SHUTTERS_WINDOW_PROTECTION = "txcd_33120015",
  EMERGENCY_RESCUE_LADDER = "txcd_33120016",
  ROPES_AND_CORDS = "txcd_33120017",
  GROUND_ANCHOR_SYSTEMS = "txcd_33120018",
  DUCT_TAPE = "txcd_33120019",
  TOILETS_WATERSENSE = "txcd_33150001",
  URINALS_WATERSENSE = "txcd_33150002",
  BATHROOM_FAUCETS_WATERSENSE = "txcd_33150003",
  SPRINKLER_BODIES_WATERSENSE = "txcd_33150004",
  IRRIGATION_CONTROLS_WATERSENSE = "txcd_33150005",
  SHOWERHEADS_WATERSENSE = "txcd_33150006",
  AUDIO_TURNTABLES = "txcd_34010001",
  DIGITAL_MUSIC_PLAYERS = "txcd_34010002",
  VIDEO_CAMERAS = "txcd_34010003",
  DIGITAL_CAMERAS = "txcd_34020001",
  DIGITAL_PICTURE_FRAMES = "txcd_34020002",
  E_BOOK_READERS = "txcd_34020003",
  HEADPHONES_EARBUDS = "txcd_34020004",
  ELECTRONICS_ACCESSORIES = "txcd_34020005",
  TELEVISIONS = "txcd_34020006",
  CONSUMER_ELECTRONICS = "txcd_34020027",
  MOBILE_PHONES = "txcd_34021000",
  MOBILE_PHONE_CHARGERS = "txcd_34021001",
  GAMING_CONSOLE_FIXED = "txcd_34022000",
  GAMING_CONSOLE_PORTABLE = "txcd_34022001",
  COMPUTER_BATTERIES = "txcd_34040001",
  COMPUTER_CABLES = "txcd_34040002",
  COMPUTER_DRIVES = "txcd_34040003",
  COMPUTER_KEYBOARDS = "txcd_34040004",
  COMPUTER_MICROPHONES = "txcd_34040005",
  COMPUTER_MONITORS = "txcd_34040006",
  COMPUTER_MOUSE = "txcd_34040007",
  COMPUTER_PRINTER = "txcd_34040008",
  COMPUTER_SPEAKERS = "txcd_34040009",
  DOCKING_STATIONS = "txcd_34040010",
  MODEMS = "txcd_34040011",
  MOTHERBOARDS = "txcd_34040012",
  PORT_REPLICATORS = "txcd_34040013",
  ROUTERS = "txcd_34040014",
  SCANNERS = "txcd_34040015",
  SOUND_CARDS = "txcd_34040016",
  VIDEO_GRAPHICS_CARD = "txcd_34040017",
  WEB_CAMERA = "txcd_34040018",
  BOOKS = "txcd_35010000",
  CHILDRENS_BOOKS = "txcd_35010001",
  RELIGIOUS_BOOKS = "txcd_35010400",
  BIBLES = "txcd_35010410",
  AUDIOBOOK_PHYSICAL = "txcd_35010500",
  NEWSPAPERS = "txcd_35020100",
  PERIODICALS = "txcd_35020200",
  MAGAZINE_SUBSCRIPTION = "txcd_35020220",
  FLEA_TICK_PRODUCTS = "txcd_36010001",
  PET_DRUGS_OTC = "txcd_36010002",
  PET_MEDICAL_SUPPLIES = "txcd_36010003",
  PET_FOOD = "txcd_36010004",
  PET_VITAMINS = "txcd_36010005",
  PET_DRUGS_RX = "txcd_36010006",
  PET_FOOD_RX = "txcd_36010007",
  PERSONAL_COMPUTERS = "txcd_37010000",
  COMPUTER_STORAGE_MEDIA = "txcd_37010003",
  PRINTER_INK = "txcd_37010036",
  STUDENT_GLOBES = "txcd_37030002",
  STUDENT_MAPS = "txcd_37030003",
  PRINTER_PAPER = "txcd_37040001",
  SCHOOL_TEXTBOOKS = "txcd_37050001",
  STUDENT_BACKPACKS = "txcd_37060001",
  CALCULATORS = "txcd_37060002",
  DAILY_PLANNERS = "txcd_37060003",
  STUDENT_PADLOCKS = "txcd_37060008",
  SCHOOL_ART_SUPPLIES = "txcd_37060009",
  DICTIONARIES_THESAURUSES = "txcd_37060010",
  STUDENT_SHEET_MUSIC = "txcd_37060011",
  SCHOOL_SUPPLIES = "txcd_37060012",
  STAPLERS_STAPLES = "txcd_37060013",
  PUSH_PINS_TACKS = "txcd_37060035",
  GRAPHING_CALCULATORS = "txcd_37060045",
  STUDENT_MUSICAL_INSTRUMENTS = "txcd_37060046",
  CANNED_SOFTWARE = "txcd_37070001",
  CANNED_SOFTWARE_NONREC = "txcd_37070002",
  SW_MAINT_PREWRITTEN_UPDATES = "txcd_37071001",
  SW_MAINT_PREWRITTEN_ALL = "txcd_37071002",
  SW_MAINT_PREWRITTEN_SVC = "txcd_37071003",
  SW_MAINT_PREWRITTEN_TANGIBLE = "txcd_37071006",
  SW_MAINT_PREWRITTEN_TANGIBLE_ALL = "txcd_37071007",
  SW_MAINT_CUSTOM_UPDATES = "txcd_37071009",
  SW_MAINT_CUSTOM_ALL = "txcd_37071010",
  SW_MAINT_CUSTOM_SVC = "txcd_37071011",
  SW_MAINT_CUSTOM_TANGIBLE = "txcd_37071014",
  SW_MAINT_CUSTOM_TANGIBLE_ALL = "txcd_37071015",
  SW_MAINT_MANDATORY_PREWRITTEN = "txcd_37071101",
  SW_MAINT_MANDATORY_TANGIBLE = "txcd_37071103",
  SW_MAINT_MANDATORY_CUSTOM = "txcd_37071104",
  SW_MAINT_MANDATORY_CUSTOM_TANGIBLE = "txcd_37071106",
  CEREAL_GRAINS = "txcd_40010000",
  PASTA = "txcd_40010001",
  RICE = "txcd_40010002",
  EDIBLE_OILS = "txcd_40020002",
  SUGAR_SUBSTITUTES = "txcd_40020004",
  FLOUR = "txcd_40020005",
  HERBS = "txcd_40020006",
  SEASONINGS = "txcd_40020007",
  FOOD_COLORING = "txcd_40020008",
  FOOD_NON_IMMEDIATE = "txcd_40040000",
  COCOA_MIX = "txcd_40040003",
  BABY_FOOD = "txcd_40040004",
  BAKING_COCOA = "txcd_40040009",
  ICE_CUBES = "txcd_40040010",
  MEAT_PRODUCTS = "txcd_40040013",
  NUTS_SEEDS = "txcd_40040016",
  NUTS_SEEDS_PROCESSED = "txcd_40040017",
  VEGETABLES = "txcd_40040019",
  CRACKER_BREAD = "txcd_40040020",
  PLAIN_BREADS = "txcd_40040021",
  SPECIALITY_BREADS = "txcd_40040022",
  FOOD_TPP_50_75 = "txcd_40050003",
  FOOD_TPP_50_90 = "txcd_40050004",
  FOOD_TPP_90_PLUS = "txcd_40050005",
  FOOD_TPP_LESS_50 = "txcd_40050006",
  FOOD_TPP_90_PLUS_CANDY = "txcd_40050007",
  FOOD_TPP_50_75_CANDY = "txcd_40050008",
  FOOD_TPP_76_89 = "txcd_40050009",
  FOOD_TPP_76_89_CANDY = "txcd_40050010",
  FOOD_CANDY_10_LESS = "txcd_40051001",
  FOOD_CANDY_11_24 = "txcd_40051002",
  FOOD_CANDY_25_49 = "txcd_40051003",
  FOOD_CANDY_50_PLUS = "txcd_40051004",
  FOOD_IMMEDIATE = "txcd_40060003",
  GRANOLA_BARS_FLOUR = "txcd_40070001",
  GRANOLA_BARS_NO_FLOUR = "txcd_40070002",
  SNACK_FOODS = "txcd_40070005",
  BISCUITS_PLAIN = "txcd_40070006",
  BISCUITS_CHOCOLATE = "txcd_40070007",
  DIETARY_SUPPLEMENTS = "txcd_40090001",
  PROTEIN_POWDER = "txcd_40090002",
  INFANT_FORMULA = "txcd_40090005",
  NUTRITIONAL_SUPPLEMENTS = "txcd_40090008",
  CANDY = "txcd_40100001",
  CANDY_FLOUR = "txcd_40100002",
  ICE_CREAM_PINT_PLUS = "txcd_40100003",
  ICE_CREAM_LESS_PINT = "txcd_40100004",
  CHEWING_GUM = "txcd_40100010",
  BREATH_MINTS = "txcd_40100011",
  DRIED_FRUIT_UNSWEETENED = "txcd_40400005",
  BEER_MALT = "txcd_41020001",
  SPIRITS = "txcd_41020002",
  WINE = "txcd_41020003",
  WATER_BOTTLED = "txcd_41030001",
  WATER_CARB_ART = "txcd_41030002",
  WATER_CARB_NAT = "txcd_41030003",
  SODA_NO_JUICE = "txcd_41040002",
  TEA_SWEET = "txcd_41040003",
  WATER_SWEET = "txcd_41040004",
  WATER_CARB_SWEET = "txcd_41040005",
  SODA_NONCARB_NO_JUICE = "txcd_41040008",
  SODA_CARB_1_9_VEG = "txcd_41040009",
  SODA_CARB_1_9_FRUIT = "txcd_41040010",
  SODA_CARB_10_24_FRUIT = "txcd_41040011",
  SODA_CARB_10_24_VEG = "txcd_41040012",
  SODA_CARB_100_JUICE = "txcd_41040013",
  SODA_CARB_25_50_FRUIT = "txcd_41040014",
  SODA_CARB_25_50_VEG = "txcd_41040015",
  SODA_CARB_51_69_FRUIT = "txcd_41040016",
  SODA_CARB_51_69_VEG = "txcd_41040017",
  SODA_CARB_70_99_FRUIT = "txcd_41040018",
  SODA_CARB_70_99_VEG = "txcd_41040019",
  SODA_NONCARB_1_9_VEG = "txcd_41040020",
  SODA_NONCARB_1_9_FRUIT = "txcd_41040021",
  SODA_NONCARB_10_24_FRUIT = "txcd_41040022",
  SODA_NONCARB_10_24_VEG = "txcd_41040023",
  SODA_NONCARB_100_JUICE = "txcd_41040024",
  SODA_NONCARB_25_50_FRUIT = "txcd_41040025",
  SODA_NONCARB_25_50_VEG = "txcd_41040026",
  SODA_NONCARB_51_69_FRUIT = "txcd_41040027",
  SODA_NONCARB_51_69_VEG = "txcd_41040028",
  SODA_NONCARB_70_99_FRUIT = "txcd_41040029",
  SODA_NONCARB_70_99_VEG = "txcd_41040030",
  COFFEE_MILK = "txcd_41050001",
  COFFEE_SWEET = "txcd_41050002",
  COFFEE_UNSWEET = "txcd_41050003",
  TEA_CARB_UNSWEET = "txcd_41050004",
  TEA_UNSWEET = "txcd_41050005",
  COFFEE_BEANS = "txcd_41050006",
  TEA_CARB_SWEET = "txcd_41050007",
  TEA_LEAVES = "txcd_41050008",
  ENERGY_DRINK_CARB = "txcd_41051001",
  ENERGY_DRINK_NONCARB = "txcd_41051002",
  NON_ALC_BEER_WINE = "txcd_41052001",
  PROTEIN_DRINK_MILK = "txcd_41053001",
  PROTEIN_DRINK_NO_MILK = "txcd_41053002",
  DRINK_MIX_MILK = "txcd_41054001",
  DRINK_MIX_WATER = "txcd_41054002",
  MILK_SUBSTITUTES = "txcd_41060003",
  MILK_COFFEE_TEA = "txcd_41060006",
  FITNESS_DUES = "txcd_50021001",
  FITNESS_INITIATION = "txcd_50021002",
  FITNESS_TRAINING = "txcd_50021003",
  FITNESS_SINGLE_USE = "txcd_50021101",
  SPORT_INSTRUCTION = "txcd_50021103",
  CASH_DONATION = "txcd_90000001",
  OPTIONAL_GRATUITY = "txcd_90020001",
  SHIPPING = "txcd_92010001",
}
